import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShellMarca, ShellSesion } from '@intelishs-group/layout';
import { BackToTop, FileViewer } from '@intelishs-group/ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ShellSesion, FileViewer, BackToTop],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  /**
   * Identidad visual del shell. Es lo UNICO que esta raiz le dice al marco: los
   * modulos, el usuario, las tarjetas de acceso, el acceso vigente, la salida de
   * sesion y el cambio de aplicacion los resuelve `<intelishs-shell-sesion>`
   * leyendo `SesionService`.
   *
   * Antes esto era `LAYOUT_ENV.systemName` en `app.config.ts`, junto a un
   * `apiUrl` y un `logoutUrl` que el shell nuevo no necesita.
   */
  protected readonly marca: ShellMarca = { nombre: 'SINAY · Gestión de Videoteca' };

  title = 'videoteca';
}
